import { Skeleton } from "primereact/skeleton";
import {
  Tree as PrimeTree,
  TreeEventNodeEvent,
  TreeExpandedKeysType,
  TreeExpandedEvent,
  TreeSelectionEvent,
  TreeMultipleSelectionKeys,
  TreeCheckboxSelectionKeys,
} from "primereact/tree";

import classes from "./PrimeTree.module.scss";

export interface TreeNode {
  key: string;
  id: string;
  label: string;
  data?: any;
  icon?: string;
  children?: TreeNode[];
  draggable?: boolean;
  droppable?: boolean;
  selectable?: boolean;
  leaf?: boolean;
  lineage?: string;
  status?: string;
  hasChildren?: boolean;
}

type TreeProps = {
  nodes: TreeNode[];
  expandedKeys: TreeExpandedKeysType;
  selectionKeys?:
    | string
    | TreeMultipleSelectionKeys
    | TreeCheckboxSelectionKeys
    | null;
  onSelect?: (e: TreeEventNodeEvent) => void;
  onUnselect?: (e: TreeEventNodeEvent) => void;
  onSelectionChange?: (e: TreeSelectionEvent) => void;
  onExpand?: (e: TreeEventNodeEvent) => void;
  onToggle?: (e: TreeExpandedEvent) => void;
  selectionMode?: "single" | "multiple" | "checkbox" | undefined;
  propagateSelectionUp?: boolean;
  propagateSelectionDown?: boolean;
  nodeTemplate?: any;
  className?: string;
  loading?: boolean;
  header?: any;
  footer?: any;
  showHeader?: boolean;
  disabled?: boolean;
};

const Tree = ({
  nodes,
  expandedKeys,
  selectionKeys,
  onSelect,
  onUnselect,
  onSelectionChange,
  onExpand,
  onToggle,
  selectionMode = "single",
  propagateSelectionUp = false,
  propagateSelectionDown = false,
  nodeTemplate = false,
  className,
  loading,
  header,
  footer,
  showHeader,
  disabled,
}: TreeProps) => {
  const treeSkeleton = (
    <div className={classes.treeSkeleton}>
      {/* TODO: refactor to different loop */}
      {[...Array(8)].map((x, i) => (
        <Skeleton key={i} height="38px"></Skeleton>
      ))}
    </div>
  );

  if (!nodes && loading) {
    return treeSkeleton;
  }

  return (
    <div>
      <PrimeTree
        value={nodes}
        selectionMode={selectionMode}
        selectionKeys={selectionKeys}
        className={className}
        header={header}
        footer={footer}
        showHeader={showHeader}
        disabled={disabled}
        onSelect={onSelect}
        onUnselect={onUnselect}
        onSelectionChange={onSelectionChange}
        onExpand={onExpand}
        nodeTemplate={nodeTemplate}
        expandedKeys={expandedKeys}
        onToggle={onToggle}
        propagateSelectionUp={propagateSelectionUp}
        propagateSelectionDown={propagateSelectionDown}
      />
    </div>
  );
};

export default Tree;

export const formatDataForTree = (
  nodes: TreeNode[],
  path: string = ""
): TreeNode[] => {
  return nodes.map((node: TreeNode, index: number) => {
    node.leaf = !node?.hasChildren;
    node.key = path ? `${path}-${index}` : `${index}`;
    return node;
  });
};

export const setChildrenAtNode = (
  nodes: TreeNode[],
  children: TreeNode[],
  path: string,
  disableAt?: string[]
) => {
  let node: TreeNode;
  const positions: string[] = path.split("-");
  positions.forEach((pos, index) => {
    //@ts-ignore
    node = index === 0 ? nodes[pos] : node.children[pos];

    if (index === positions.length - 1) {
      node.children = children;
      if (disableAt) {
        node.children.forEach((child) => {
          if (node.selectable === false || disableAt.includes(child.id)) {
            child.selectable = false;
          }
        });
      }
      if (children.length === 0) node.leaf = true;
    }
  });

  return [...nodes];
};
